<template>
    <QuotationFeedback
        :modal="quotationFeedbackModal"
        :toast="quotationFeedbackToast"
        @close-modal="CloseQuotationFeedbackModal"
        @close-toast="CloseQuotationFeedbackToast"
    />
     <BreadcrumbsProject
        v-if="!isDeluxeLayout"
        class="d-print-none"
        :breadcrumbs="[
            {
                link : dotnetUrl +'/project/list',
                title : $t('Projects'),
                isRouterLink: false
            },
            {
                link : projectUrl +'/Project/' + projectInfo._id,
                title :  (projectInfo.projectNumber || '-') +' ' + (projectInfo.projectName || ''),
                isRouterLink: false
            },
            {
                link : '/boq/' + projectInfo._id+'/quotation/list',
                title : $t('Quotations'),
                isRouterLink: true
            },
            {
                link : '/boq/' + quotationId +'/quotation/item',
                title : (quotationDataIntial.quotationNumber || '') + ' ' + (quotationDataIntial.quotationName || '')  ,
                isRouterLink: true
            },
        ]"
    ></BreadcrumbsProject>
    <div class="d-print-none" :class="{ 'border-bottom': !isDeluxeLayout }">
        <StepItem2 :active-index="isDeluxeLayout ? 2 : null" :deluxe="isDeluxeLayout"></StepItem2>
    </div>
    <div
        v-if="isDeluxeLayout"
        class="deluxe-project-back quotation-deluxe-back d-print-none"
    >
        <router-link
            v-if="QuotationProjectId"
            :to="{ name : 'BoqListQuotation', params : { id : QuotationProjectId } }"
        >
            <i class="fa-solid fa-chevron-left"></i> {{ $t('Back To Quotation') }}
        </router-link>
    </div>
    <div
        v-if="isDeluxeLayout"
        class="quotation-deluxe-header d-print-none"
    >
        <div class="quotation-deluxe-heading">
            <span v-if="!isEditMode" class="quotation-deluxe-eyebrow">{{ $t('Quotation') }}</span>
            <h1 class="deluxe-page-title">
                {{ isEditMode ? $t('Quotation Module.Update Quotation') : QuotationDisplayTitle }}
            </h1>
            <div class="quotation-deluxe-attached" v-if="!isEditMode && FirstAttachedBoq">
                <span>{{ $t('View Attached BOQ') }}:</span>
                <router-link :to="{name : 'BoqBuilder', params : {id : FirstAttachedBoq._id}}">
                    {{ FirstAttachedBoq.name }}
                    <span v-if="GetApprovalStageName(FirstAttachedBoq.approvalStage)">({{ GetApprovalStageName(FirstAttachedBoq.approvalStage) }})</span>
                    &gt;
                </router-link>
            </div>
        </div>
        <div class="quotation-deluxe-actions">
            <div class="quotation-deluxe-action-row">
                <template v-if="!isEditMode">
                    <button
                        type="button"
                        class="quotation-deluxe-action-button quotation-deluxe-action-button--muted"
                        @click="()=>{ isEditMode = true; haveChanges = false }"
                        v-if="permission.indexOf(ModuleActionList.BOQ_QUOTATION_EDIT)>-1 && !IsPublished"
                    >
                        <span>{{ $t('Edit') }}</span>
                        <i class="fa-solid fa-pen-to-square"></i>
                    </button>
                    <button type="button" class="quotation-deluxe-action-button quotation-deluxe-action-button--print" @click="ExportToPdf">
                        <span>{{ $t('Print') }}</span>
                        <i class="fa-solid fa-print"></i>
                    </button>
                    <button
                        type="button"
                        class="quotation-deluxe-action-button quotation-deluxe-action-button--muted"
                        @click="PublishQuotation"
                        v-if="quotationDataIntial.approvalStage==ApprovalStageBoq.APPROVED && permission.indexOf(ModuleActionList.BOQ_QUOTATION_PUBLISH)>-1"
                    >
                        <span>{{ $t('Quotation Module.Contract Signed') }}</span>
                        <i class="fa-solid fa-file-circle-check"></i>
                    </button>
                </template>
                <template v-else>
                    <button type="button" class="custom-btn custom-btn--cancel quotation-deluxe-edit-cancel" @click="CancelEdit">
                        {{ $t('Cancel') }}
                    </button>
                    <button
                        type="button"
                        class="custom-btn quotation-deluxe-save-button"
                        @click="UpdateQuotation"
                        :disabled="!CanSaveQuotation"
                    >
                        {{ $t('Save Changes') }}
                    </button>
                </template>
                <button
                    type="button"
                    class="custom-btn"
                    v-if="!isEditMode && quotationDataIntial.approvalStage!=ApprovalStageBoq.FOR_APPROVAL && !IsPublished && permission.indexOf(ModuleActionList.BOQ_QUOTATION_PUBLISH)>-1"
                    @click="OpenWorkFlowModal"
                >
                    <span>{{ $t('Send For Approval') }}</span>
                    <i class="fas fa-paper-plane"></i>
                </button>
            </div>
            <span v-if="!isEditMode" :class="['quotation-deluxe-status-pill', GetStatusClass(quotationDataIntial.approvalStage)]">
                {{ QuotationStatusDisplay }}
            </span>
        </div>
    </div>
    <div
        :class="isDeluxeLayout ? 'd-print-none quotation-deluxe-workflow' : 'd-print-none row mt-2'"
        v-if="quotationDataIntial.approvalStage==ApprovalStageBoq.FOR_APPROVAL"
    >
        <BoqProcessWorkFlow
        v-if="processItemData._id"
        :processItemData="processItemData" 
        :showApprovalDisapprove="false"
        :showGoToApproval="true"
        />
    </div>
    <FigureCurrencyNote v-if="isDeluxeLayout && !isEditMode" class="quotation-deluxe-currency-note" :currency="projectInfo.currencyId" />
    <div class="row my-3 ms-2 me-2 align-content-center" v-if="!isDeluxeLayout">
        <div class="col-md-4 d-print-none">
            <span :class="'align-self-center badge ' + ApprovalStageBoqObj[quotationDataIntial.approvalStage -1].color">
                {{ QuotationStatusDisplay }}
            </span>
        </div>
        <div class="col-md-4 d-print-none">
            <div class="d-flex justify-content-center">
                <h5>{{$t('Quotation')}}</h5>
            </div>
        </div>
        <div class="col-md-4 d-print-none">
            <div class="d-flex justify-content-end ">
                <div class="btn-group" role="group" v-show="!isEditMode">
                    <button class="btn btn-primary" @click="()=>{ isEditMode = true}" v-if="permission.indexOf(ModuleActionList.BOQ_QUOTATION_EDIT)>-1 && !IsPublished" >
                        <i class="fa-solid fa-edit"></i> {{$t('Edit')}} 
                    </button>
                    <button class="btn btn-primary" @click="ExportToPdf" >
                        <i class="fa-solid fa-print"></i> {{$t('Print')}}
                    </button>
                    <!-- <button class="btn btn-primary" @click="PublishQuotation" v-if="quotationDataIntial.approvalStage==ApprovalStageBoq.APPROVED && permission.indexOf(ModuleActionList.BOQ_QUOTATION_PUBLISH)>-1" >
                        <i class="fa-solid fa-file-circle-check"></i> {{ $t('Quotation Module.Contract Signed') }}
                    </button> -->
                </div>
                
                <div v-show="isEditMode">
                    <button class="btn btn-default me-1" @click="CancelEdit">
                        <i class="fa-solid fa-times"></i> {{$t('Cancel')}}
                    </button>
                    <button class="btn btn-success" @click="UpdateQuotation" :disabled="!CanSaveQuotation">
                        <i class="fa-solid fa-floppy-disk"></i> {{$t('Save Changes')}}
                    </button>
                </div>
            </div>
        </div>
    </div>
    <div :class="isDeluxeLayout ? ['quotation-deluxe-content', 'print-content', { 'quotation-deluxe-content--edit': isEditMode }] : 'bg-white p-3 print-content border rounded m-3'">
        <fieldset :disabled="isLoading">
            
            <div
                v-if="isDeluxeLayout"
                class="quotation-deluxe-details"
                :class="{ 'quotation-deluxe-details--edit': isEditMode }"
            >
                <section class="quotation-deluxe-card quotation-deluxe-card--content">
                    <template v-if="!isEditMode">
                        <div class="quotation-deluxe-report-head">
                            <div class="quotation-deluxe-report-address">
                                <span class="quotation-deluxe-report-label">{{ $t('To') }} ({{ $t('Client') }})</span>
                                <h2>{{ quotationData.attentionClient.userId.company || '-' }}</h2>
                                <p class="quotation-deluxe-address-line">
                                    <span>{{ $t('Address') }}:</span>
                                    <strong style="white-space: pre-line">{{ quotationData.address || '-' }}</strong>
                                </p>
                                <p>
                                    <span>{{ $t('Issue Date') }}:</span>
                                    <strong>{{ quotationData.contractDate ? ReformatDate(quotationData.contractDate) : '-' }}</strong>
                                </p>
                                <div class="quotation-deluxe-report-meta">
                                    <p>
                                        <span>{{ $t('Attention') }}:</span>
                                        <strong class="text-capitalize">{{ quotationData.attentionClient.userId.fullname || '-' }}</strong>
                                    </p>
                                    <p class="quotation-deluxe-report-project">
                                        <strong>{{ quotationData.quotationName || '-' }}</strong>
                                    </p>
                                    <p>
                                        <span>{{ $t('Via Email/Fax') }}:</span>
                                        <strong>{{ quotationData.attentionClient.userId.email || '-' }}</strong>
                                    </p>
                                    <p>
                                        <span>{{ $t('Remarks') }}:</span>
                                        <strong>{{ quotationData.remark || 'N/A' }}</strong>
                                    </p>
                                </div>
                            </div>
                            <div class="quotation-deluxe-report-number">
                                <p>{{ $t('Quotation No') }}</p>
                                <h4>{{ quotationData.quotationNumber || '-' }}</h4>
                            </div>
                        </div>
                    </template>
                    <template v-else>
                        <div class="quotation-deluxe-edit-grid">
                            <section class="quotation-deluxe-edit-card quotation-deluxe-edit-card--main">
                                <div class="quotation-deluxe-block-title">{{ $t('Content') }}</div>
                                <hr class="quotation-deluxe-edit-divider" />
                                <div class="quotation-deluxe-form-grid">
                                    <label class="quotation-deluxe-field quotation-deluxe-field--wide">
                                        <span class="quotation-deluxe-label">{{ $t('To') }}</span>
                                        <textarea
                                            class="form-control quotation-deluxe-textarea"
                                            :placeholder="$t('Enter Address')"
                                            v-model="quotationData.address"
                                        ></textarea>
                                    </label>
                                    <label class="quotation-deluxe-field">
                                        <span class="quotation-deluxe-label">{{ $t('Date') }} <span class="quotation-required-label" v-if="!quotationData.contractDate">({{ $t('Required').toLowerCase() }})</span></span>
                                        <DatePicker v-model="quotationData.contractDate" class="quotation-deluxe-control" elemId="quotation-date-contractDate" />
                                        <small class="text-warning" v-if="validationErrors.contractDate">{{ $t('Required') }}</small>
                                    </label>
                                    <label class="quotation-deluxe-field">
                                        <span class="quotation-deluxe-label">{{ $t('Quotation Module.Quotation Number') }} <span class="quotation-required-label" v-if="!quotationData.quotationNumber">({{ $t('Required').toLowerCase() }})</span></span>
                                        <input type="text" class="form-control quotation-deluxe-control" :placeholder="$t('Quotation No')" v-model="quotationData.quotationNumber" />
                                        <small class="text-warning" v-if="!quotationData.quotationNumber">{{ $t('Required') }}</small>
                                    </label>
                                    <div class="quotation-deluxe-field quotation-deluxe-field--wide">
                                        <span class="quotation-deluxe-label">{{ $t('Attention') }} <span class="quotation-required-label" v-if="!HasAttentionClient">({{ $t('Required').toLowerCase() }})</span></span>
                                        <Select2
                                        ref="select2ClientFromDirectory"
                                        :filterQuery="SearchClientFromProjectDirectory"
                                        indexValue="_id"
                                        labelName="fullname"
                                        :placeHolder="$t('Quotation Module.Search Client From Project')"
                                        :iniLabel="attentionTo.name"
                                        v-model:optionValue="attentionTo.directoryId"
                                        ></Select2>
                                        <small class="text-warning" v-if="validationErrors.attention">{{ $t('Required') }}</small>
                                    </div>
                                    <label class="quotation-deluxe-field">
                                        <span class="quotation-deluxe-label">{{ $t('Quotation Module.Quotation Name') }} <span class="quotation-required-label" v-if="!quotationData.quotationName">({{ $t('Required').toLowerCase() }})</span></span>
                                        <input type="text" class="form-control quotation-deluxe-control" :placeholder="$t('Enter Quotation Name')" v-model="quotationData.quotationName" />
                                        <small class="text-warning" v-if="!quotationData.quotationName">{{ $t('Required') }}</small>
                                    </label>
                                    <label class="quotation-deluxe-field">
                                        <span class="quotation-deluxe-label">{{ $t('Layout Date based') }} <span class="quotation-required-label" v-if="!quotationData.layoutDate">({{ $t('Required').toLowerCase() }})</span></span>
                                        <DatePicker v-model="quotationData.layoutDate" class="quotation-deluxe-control" elemId="quotation-date-layoutDate" />
                                        <small class="text-warning" v-if="validationErrors.layoutDate">{{ $t('Required') }}</small>
                                    </label>
                                    <label class="quotation-deluxe-field quotation-deluxe-field--wide">
                                        <span class="quotation-deluxe-label">{{ $t('Remarks') }}</span>
                                        <textarea class="form-control quotation-deluxe-textarea" :placeholder="$t('Enter Remarks')" v-model="quotationData.remark"></textarea>
                                    </label>
                                </div>
                            </section>
                            <aside class="quotation-deluxe-edit-side">
                                <section class="quotation-deluxe-edit-card">
                                    <div class="quotation-deluxe-block-title">{{ $t('Status') }}</div>
                                    <hr class="quotation-deluxe-edit-divider" />
                                    <div class="quotation-deluxe-edit-status">
                                        <span
                                            class="quotation-deluxe-toggle"
                                            :class="{ 'is-active': quotationDataIntial.approvalStage!=ApprovalStageBoq.CANCELED }"
                                        >
                                            <span></span>
                                        </span>
                                        <span class="quotation-deluxe-edit-status-text">
                                            <strong>{{ $t('Active') }}</strong>
                                            <small>{{ CurrentApprovalStageName }}</small>
                                        </span>
                                    </div>
                                </section>
                                <section class="quotation-deluxe-edit-card">
                                    <div class="quotation-deluxe-block-title">{{ $t('Associated Project') }}</div>
                                    <hr class="quotation-deluxe-edit-divider" />
                                    <div class="quotation-deluxe-readonly-field">
                                        <span class="quotation-deluxe-label">{{ $t('Project') }}</span>
                                        <div class="quotation-deluxe-readonly-control">{{ ProjectDisplayName }}</div>
                                    </div>
                                </section>
                            </aside>
                        </div>
                    </template>
                </section>
            </div>
            <div v-if="!isDeluxeLayout" class="row ">
                <div class="col-sm-12 d-none d-print-block">
                    <div class="float-end">
                        <a><img src="https://staff.mmoseronelink.com/mmoser-associates.svg"  alt="" width="300" height="40"></a>
                    </div>
                </div>
                <div class="col-sm-6 d-none d-print-block">
                    <div class="d-flex">
                        <span class="fw-bold">{{$t('To')}}:</span>
                        <div style="white-space: pre-line" >
                            {{quotationData.address}}
                        </div>
                    </div>
                </div>
                <div class="col-sm-6 d-none d-print-inline">
                     <div class="float-end">
                        <div>
                            <span class="fw-bold">{{$t('Date')}}:</span> {{quotationData.contractDate ? ReformatDate(quotationData.contractDate) : 'N/A'}}
                        </div>
                        <div >
                            <span class="fw-bold">{{$t('Quotation Module.QTN No')}}:</span>  
                            <span > {{quotationData.quotationNumber}}</span>
                        </div>
                    </div>
                </div>
                <div class="col-md-6 d-print-none">
                    <div class=" pt-1">
                        <div v-if="!isEditMode" class="d-flex">
                            <span class="fw-bold">{{$t('To')}}:</span>
                            <div style="white-space: pre-line" >
                                {{quotationData.address}}
                            </div>
                        </div>
                        <div v-else class="">
                            <span class="fw-bold">{{$t('To')}}:</span>
                            <textarea class="form-control width-50" style="height:150px" v-model="quotationData.address">
                            </textarea>
                        </div>
                    </div>
                </div>
                <div class="col-md-6 d-print-none text-end">
                    <button class="btn btn-outline-primary" v-if="quotationDataIntial.approvalStage!=ApprovalStageBoq.FOR_APPROVAL && !IsPublished && permission.indexOf(ModuleActionList.BOQ_QUOTATION_PUBLISH)>-1"
                    @click="OpenWorkFlowModal"
                    ><i class="fas fa-paper-plane"></i> {{ $t('Send For Approval') }}</button>
                </div>
                <div class="col-md-12 d-print-none">
                    <div>
                        <div v-if="!isEditMode">
                            <span class="fw-bold">{{$t('Date')}}:</span>  {{quotationData.contractDate ? ReformatDate(quotationData.contractDate) : '-'}}
                        </div>
                        <div v-else>
                            <span class="fw-bold">{{$t('Date')}} <span class="quotation-required-label" v-if="!quotationData.contractDate">({{ $t('Required').toLowerCase() }})</span>:</span>
                            <DatePicker v-model="quotationData.contractDate" class="width-50" elemId="quotation-date-contractDate" />
                            <small class="text-warning d-block" v-if="validationErrors.contractDate">{{ $t('Required') }}</small>
                        </div>
                        <div >
                            <span class="fw-bold">{{$t('Quotation No')}} <span class="quotation-required-label" v-if="!quotationData.quotationNumber">({{ $t('Required').toLowerCase() }})</span>:</span>
                            <span v-if="!isEditMode" > {{quotationData.quotationNumber}}</span>
                            <div v-else>
                                <input type="text" class="form-control width-50"  :placeholder="$t('Quotation No')" v-model="quotationData.quotationNumber" />
                                <small class="text-warning" v-if="!quotationData.quotationNumber">{{ $t('Required') }}</small>
                            </div>
                        </div>
                    </div>
                    
                </div>
                <div class="col-md-12 col-sm-12">
                    <div class="mt-3">
                        <div class="">
                            <span class="fw-bold d-print-none">{{$t('Attention')}} <span class="quotation-required-label" v-if="isEditMode && !HasAttentionClient">({{ $t('Required').toLowerCase() }})</span>:</span>
                            <span class="fw-bold d-none d-print-inline">{{ $t('Quotation Module.Attn') }} :</span>  
                            <span v-if="!isEditMode" class="text-capitalize">{{quotationData.attentionClient.userId.fullname || '-'}}</span>
                            <div v-else>
                                <div class="width-50">
                                    <Select2 
                                    ref="select2ClientFromDirectory"
                                    :filterQuery="SearchClientFromProjectDirectory"
                                    indexValue="_id"
                                    labelName="fullname"
                                    :placeHolder="$t('Quotation Module.Search Client From Project')"
                                    :iniLabel="attentionTo.name"
                                    v-model:optionValue="attentionTo.directoryId"
                                    ></Select2>
                                    <small class="text-warning d-block" v-if="validationErrors.attention">{{ $t('Required') }}</small>
                                </div>
                            </div> 
                        </div>
                    </div>
                </div>
                <div class="col-md-12 col-sm-12">
                    <div class="mt-3 ms-3">
                        <div v-if="!isEditMode">{{quotationData.quotationName}}</div>
                        <div v-else>
                            <div>
                                <span class="fw-bold ">{{$t('Quotation Module.Quotation Name')}} <span class="quotation-required-label" v-if="!quotationData.quotationName">({{ $t('Required').toLowerCase() }})</span></span>
                                <input type="text" class="form-control width-50"  :placeholder="$t('Quotation Module.Quotation Name')" v-model="quotationData.quotationName" />
                                <small class="text-warning" v-if="!quotationData.quotationName">{{ $t('Required') }}</small>
                            </div>
                        </div>
                        <div v-if="!isEditMode">{{$t('Quotation Module.Based on confirmed layout dated')}} {{FormatLayoutDate}}</div>
                        <div  v-else>
                            <span class="fw-bold">{{$t('Layout Date based')}} <span class="quotation-required-label" v-if="!quotationData.layoutDate">({{ $t('Required').toLowerCase() }})</span></span>
                            <DatePicker v-model="quotationData.layoutDate" class="width-50" elemId="quotation-date-layoutDate" />
                            <small class="text-warning d-block" v-if="validationErrors.layoutDate">{{ $t('Required') }}</small>
                        </div>
                    </div>
                </div>
                <div class="col-md-12 col-sm-12">
                    <div class="mt-3">
                        <div>
                            <span class="fw-bold d-print-none">{{$t('Remark')}}:</span>  
                            <span class="fw-bold d-none d-print-inline">{{$t('Quotation Module.RE')}}:</span>  
                            <span v-if="!isEditMode">{{quotationData.remark || 'N/A'}}</span>
                            <div v-else>
                                <textarea class="form-control width-50" style="height:150px" v-model="quotationData.remark"></textarea>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div :class="isDeluxeLayout ? 'quotation-deluxe-summary print-body' : 'pt-3 print-body'">
                <div class="d-none d-print-block bg-separator">
                    {{$t('Quotation Module.Summary')}}
                </div>
                <div v-if="isDeluxeLayout && isEditMode" class="quotation-deluxe-edit-card-head d-print-none">
                    <div class="quotation-deluxe-block-title">{{ $t('Table') }}</div>
                    <div class="quotation-deluxe-summary-actions">
                        <button
                            class="custom-btn quotation-deluxe-table-action quotation-deluxe-table-action--new"
                            v-if="permission.indexOf(ModuleActionList.BOQ_QUOTATION_EDIT)>-1"
                            data-bs-toggle="modal"
                            data-bs-target="#ModalNewQuotationAdd"
                        >
                            <span>{{ $t('Quotation Module.New BoQ') }}</span>
                            <i class="fa-solid fa-plus"></i>
                        </button>

                        <button
                            class="custom-btn quotation-deluxe-table-action quotation-deluxe-table-action--attach"
                            v-if="permission.indexOf(ModuleActionList.BOQ_QUOTATION_EDIT)>-1"
                            @click="OpenAddBoqToQuotation"
                            data-bs-toggle="modal"
                            data-bs-target="#ModalAddBoqQuotation"
                        >
                            <span>{{ $t('Quotation Module.Existing BoQ') }}</span>
                            <i class="fa-solid fa-file-lines"></i>
                        </button>
                    </div>
                </div>
                <div class="d-flex justify-content-end d-print-none" v-else-if="isEditMode" >
                    <button class="btn btn-outline-primary me-1"
                    v-if="permission.indexOf(ModuleActionList.BOQ_QUOTATION_EDIT)>-1"
                    data-bs-toggle="modal" data-bs-target="#ModalNewQuotationAdd"
                    ><i class="fa-solid fa-plus"></i> {{$t('Quotation Module.New BoQ')}} </button>

                    <button class="btn btn-outline-primary"
                    v-if="permission.indexOf(ModuleActionList.BOQ_QUOTATION_EDIT)>-1"
                    @click="OpenAddBoqToQuotation"
                    data-bs-toggle="modal" data-bs-target="#ModalAddBoqQuotation"
                    ><i class="fa-solid fa-plus"></i> {{$t('Quotation Module.Existing BoQ')}} </button>
                </div>
                <FigureCurrencyNote v-if="!isDeluxeLayout" :currency="projectInfo.currencyId" />
                <div v-if="isSummaryLoading">
                    <Loader />
                </div>
                <div :class="isDeluxeLayout ? 'quotation-deluxe-table-wrap' : 'table-responsive'" v-else>
                    <BoqQuotationBoqSummary
                    :dataRow="summaryByBoqList"
                    :unitOfMeasure="quotationData.projectId?.unit_of_measure"
                    />
                    <small :class="isDeluxeLayout ? 'quotation-deluxe-validation' : 'text-danger'" v-if="isEditMode && validationErrors.attachedBoq">
                        {{ $t('Attach at least one Bill of Quantity before sending for approval.') }}
                    </small>
                </div>
                <!-- <div class="table-responsive" v-else>
                    <table class="table " >
                        <thead>
                            <th>Item</th>
                            <th>Description</th>
                            <th class="text-end">%</th>
                            <th class="text-end">p{{quotationData.projectId?.unit_of_measure}}</th>
                            <th class="text-end">Amount</th>
                        </thead>
                        <tbody v-if="summaryList.length==0">
                            <tr class="d-print-none">
                                <td colspan="5" class="text-center">
                                    No Data Found
                                </td>
                            </tr>
                            <tr class="d-none d-print-table-row">
                                <td  colspan="5" class="text-center ">
                                    No Data Found
                                </td>
                            </tr>
                        </tbody>
                        <tbody v-else>
                            <template v-for="(item,key) in SummaryRender" :key="key" >
                                <tr class="bg-light fw-bold" v-if="item.willShowParent">
                                    <td >{{item.label}}</td>
                                    <td colspan="4 " class="fw-bold">{{item.parent.name}}</td>
                                </tr>
                                <tr>
                                    <td>{{item.index}}</td>
                                    <td>{{item.costCode.name}}</td>
                                    <td class="text-end">{{item.percentTotal}}%</td>
                                    <td class="text-end">{{item.perSize}}</td>
                                    <td class="text-end">{{item.sellTotal}}</td>
                                </tr>
                                <tr v-if="item.subTotal">
                                    <td></td>
                                    <td class="fw-bold text-end">Sub Total of Section {{item.subTotal.label}}</td>
                                    <td class="text-end fw-bold">{{item.subTotal.percentTotal}}%</td>
                                    <td class="text-end fw-bold">{{item.subTotal.perSize}}</td>
                                    <td class="text-end fw-bold">{{item.subTotal.total}}</td>
                                </tr>
                                <tr v-if="item.overAllTotal">
                                    <td></td>
                                    <td class="fw-bold text-end">Total A-{{item.overAllTotal.lastLabel}} (Exclude GST)</td>
                                    <td class="text-end fw-bold">{{item.overAllTotal.percentTotal}}%</td>
                                    <td class="text-end fw-bold">{{item.overAllTotal.perSize}}</td>
                                    <td class="text-end fw-bold">{{item.overAllTotal.total}}</td>
                                </tr>
                                <tr v-if="item.overAllTotal">
                                    <td colspan="4" class="text-end">Subject to prevailing GST rates</td>
                                    <td ></td>
                                </tr>
                            </template>
                            <tr>
                                <td colspan="4" class="text-end">
                                    Approximate Area
                                </td> 
                                <td>
                                    {{quotationData.projectId?.size || ''}}{{quotationData.projectId?.unit_of_measure || ''}}
                                </td> 
                            </tr>
                        </tbody>
                    </table>
                </div> -->
                <div v-if="!isDeluxeLayout || isEditMode" :class="isDeluxeLayout ? 'quotation-deluxe-link-row d-print-none' : 'd-print-none'">
                    <router-link :to="{name : 'BoqQuotationAttachedItems', params : {id : quotationData._id}, query : {returnUrl : returnUrl}} " :class="isDeluxeLayout ? 'custom-btn custom-btn--cancel' : 'btn btn-outline-primary'">
                        <i class="fa-solid fa-paperclip"></i> {{$t('View Attached Bill of Quantities')}}
                    </router-link>
                </div>
            </div>
            <div class="d-none d-print-inline pager-count">  </div>
            <div class="break-after"></div>
            <BoqQuotationHeaderReadOnly class="d-none d-print-block" :quotationData="quotationData" />
            <div :class="isDeluxeLayout ? 'quotation-deluxe-section-row print-body' : 'row print-body'" >
                <div class="col-md-12 col-sm-12">
                    <div :class="isDeluxeLayout ? 'quotation-deluxe-section quotation-deluxe-section--rich' : 'pt-2'" >
                        <div class="d-none d-print-block bg-separator">
                            {{$t('Notes/Remark(Scope of Work)')}}
                        </div>
                        <div :class="isDeluxeLayout ? 'quotation-deluxe-block-title d-print-none' : 'd-print-none fw-bold'">{{$t('Notes/Remark(Scope of Work)')}}:</div>
                        <div v-if="!isEditMode" class="quotation-deluxe-html" v-html="DisplayScopeOfWork"></div>
                        <RichTextEditor v-model:modelValue="EditableScopeOfWork" v-else :placeHolder="$t('Notes/Remark(Scope of Work)')" :height="'200'" />
                    </div>
                </div>
            </div>
            
            <div class="d-none d-print-inline pager-count">  </div>
            <div class="break-after"></div>
            <BoqQuotationHeaderReadOnly class="d-none d-print-block" :quotationData="quotationData" />
            <div :class="isDeluxeLayout ? 'quotation-deluxe-section-row print-body' : 'row print-body'" >
                <div class="col-md-12 col-sm-12">
                    <div :class="isDeluxeLayout ? 'quotation-deluxe-section quotation-deluxe-section--rich' : 'pt-2'" >
                        <div class="d-none d-print-block bg-separator">
                            {{$t('Terms & Conditions')}}
                        </div>
                        <div :class="isDeluxeLayout ? 'quotation-deluxe-block-title d-print-none' : 'd-print-none fw-bold'">{{$t('Terms & Conditions')}}</div>
                        <div v-if="!isEditMode" class="quotation-deluxe-html" v-html="DisplayTermAndConditions"></div>
                        <RichTextEditor v-else v-model:modelValue="EditableTermAndConditions" :placeHolder="$t('Terms & Conditions')" :height="'200'" />
                    </div>
                </div>
                
                <div class="col-md-12 d-print-none" >
                    <div :class="isDeluxeLayout ? 'quotation-deluxe-section quotation-deluxe-compact-section' : ''">
                        <div :class="isDeluxeLayout ? 'quotation-deluxe-block-title' : 'fw-bold'">
                            {{$t('Attachments')}}
                            <span class="quotation-required-label" v-if="isEditMode && !HasQuotationAttachments()"></span>
                        </div>
                        <hr v-if="isDeluxeLayout && isEditMode" class="quotation-deluxe-edit-divider" />
                        <template v-if="isEditMode">
                            <div v-if="isDeluxeLayout" class="quotation-deluxe-file-upload">
                                <input
                                    id="quotation-deluxe-file-upload"
                                    type="file"
                                    ref="fileDatas"
                                    accept="application/pdf"
                                    multiple
                                    class="quotation-deluxe-file-input"
                                    @change="OnChangeFiles"
                                />
                                <button type="button" class="quotation-deluxe-file-label" @click="OpenAttachmentPicker">
                                    <span class="quotation-deluxe-file-icon">
                                        <i class="fa-solid fa-paperclip"></i>
                                    </span>
                                    <span class="quotation-deluxe-file-copy">
                                        <strong>{{$t('Attachments')}}</strong>
                                        <small>{{ $t('Choose PDF files to attach') }}</small>
                                    </span>
                                    <span class="quotation-deluxe-file-button">{{$t('Upload')}}</span>
                                </button>
                            </div>
                            <input v-else type="file" ref="fileDatas" accept="application/pdf" multiple class="form-control quotation-deluxe-control" @change="OnChangeFiles" />
                        </template>
                    </div>
                </div>
                <div class="col-md-12 d-print-none" >
                    <div :class="isDeluxeLayout ? 'quotation-deluxe-attachment-list' : 'row pt-3'">
                        <div :class="isDeluxeLayout ? 'quotation-deluxe-attachment-item' : 'col-md-4'" v-for="(item,key) in quotationData.attachments" :key="key">
                            <template v-if="isDeluxeLayout">
                                <span :class="['quotation-deluxe-attachment-icon', { 'is-pending': item._id==0 }]">
                                    <i :class="item._id==0 ? 'fa-solid fa-file-arrow-up' : 'fa-solid fa-paperclip'"></i>
                                </span>
                                <span class="quotation-deluxe-attachment-copy">
                                    <button
                                        v-if="item._id!=0"
                                        type="button"
                                        class="quotation-deluxe-attachment-name"
                                        @click="OnclickLink(item.sharepointLink)"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        :title="$t('Click to open in Sharepoint')"
                                    >
                                        {{ item.attachmentName }}
                                    </button>
                                    <span v-else class="quotation-deluxe-attachment-name">
                                        {{ item.attachmentName }}
                                    </span>
                                    <small>{{ item._id==0 ? $t('Ready to upload') : 'PDF' }}</small>
                                </span>
                                <button
                                    type="button"
                                    class="quotation-deluxe-attachment-remove"
                                    v-if="isEditMode"
                                    @click="RemoveAttachment(item._id,item.attachmentName)"
                                >
                                    <i class="fa-solid fa-times"></i> {{$t('Remove')}}
                                </button>
                            </template>
                            <div class="input-group mb-3" v-else-if="item._id!=0">
                                <span class="input-group-text bg-white" ><i class="fa-solid fa-paperclip"></i></span>
                                <input type="text" role="button" @click="OnclickLink(item.sharepointLink)" 
                                data-bs-toggle="tooltip" data-bs-placement="top" :title="$t('Click to open in Sharepoint')"
                                class="form-control text-decoration-underline text-primary" readonly :value="item.attachmentName">
                                <span class="text-danger ps-2 pt-2 fw-bold" role="button" v-if="isEditMode" @click="RemoveAttachment(item._id,item.attachmentName)"><i class="fa-solid fa-times"></i> {{$t('Remove')}} </span>
                            </div>
                            <div class="input-group mb-3  " v-else>
                                <span class="input-group-text bg-white text-success" ><i class="fa-solid fa-link-slash"></i></span>
                                <input type="text" 
                                data-bs-toggle="tooltip" data-bs-placement="top" :title="$t('File to be Uploaded')"
                                class="form-control text-success" readonly :value="item.attachmentName">
                                <span class="text-danger ps-2 pt-2 fw-bold" role="button" v-if="isEditMode" @click="RemoveAttachment(item._id,item.attachmentName)"><i class="fa-solid fa-times"></i> {{$t('Remove')}} </span>
                            </div>
                            
                            <!-- <a class="text-primary fw-bold" role="button" :href="item.sharepointLink" target="_blank"> <i class="fa-solid fa-paperclip"></i> {{item.attachmentName}}</a> 
                            <span class="text-danger" v-if="isEditMode"><i class="fa-solid fa-times"></i> Remove </span> -->
                        </div>
                    </div>
                </div>
                <div class="col-md-12 col-sm-12  d-print-none">
                    <div :class="isDeluxeLayout ? 'quotation-deluxe-section quotation-deluxe-compact-section' : 'pt-2'" >
                        <div :class="isDeluxeLayout ? 'quotation-deluxe-block-title' : 'fw-bold'">{{$t('Construction Schedule')}}</div>
                        <div v-if="!isEditMode">
                            {{quotationData.constructionSchedule || '-'}}
                        </div>
                        <input v-else type="text" class="form-control quotation-deluxe-control" :placeholder="$t('Quotation Module.Link of the construction schedule')" v-model="quotationData.constructionSchedule"  />
                    </div>
                </div>
                <div class="col-md-12 col-sm-12 d-print-none" >
                    <div :class="isDeluxeLayout ? 'quotation-deluxe-section quotation-deluxe-compact-section' : 'pt-2'" >
                        <div :class="isDeluxeLayout ? 'quotation-deluxe-block-title' : 'fw-bold'">{{$t('Construction Drawings')}}</div>
                        <div v-if="!isEditMode">
                            {{quotationData.constructionDrawings || '-'}}
                        </div>
                        <input v-else type="text" class="form-control quotation-deluxe-control" :placeholder="$t('Quotation Module.Link of the construction drawings')"  v-model="quotationData.constructionDrawings"  />
                    </div>
                </div>
                <div
                    v-if="isDeluxeLayout && isEditMode"
                    class="col-md-12 col-sm-12 quotation-deluxe-signing-card d-print-none"
                >
                    <div class="quotation-deluxe-block-title">{{ $t('Quotation Module.Signing details') }}</div>
                    <div class="quotation-deluxe-signing-grid">
                        <div class="quotation-deluxe-signing-field">
                            <div class="quotation-deluxe-signing-field-head">
                                <span class="quotation-deluxe-label">{{$t('Submitted By')}}</span>
                                <p>M. Moser Associates (S) Pte Limited</p>
                            </div>
                            <div class="quotation-deluxe-signing-row" v-for="(item, key) in submittedTo" :key="key">
                                <Select2
                                ref="select2UserFromDirectory"
                                :filterQuery="SearchUserFromProjectDirectory"
                                indexValue="directoryId"
                                labelName="fullname"
                                :placeHolder="$t('Search Here')"
                                :iniLabel="item.name"
                                v-model:optionValue="item.directoryId"
                                :onOptionClick="AddNewSubmittedLine"
                                ></Select2>
                                <button type="button" class="quotation-deluxe-remove-button" @click="RemoveSubmittedLine(item.directoryId)">
                                    <i class="fa-solid fa-times"></i> {{$t('Remove')}}
                                </button>
                            </div>
                            <small class="quotation-deluxe-validation" v-if="validationErrors.submittedBy || !HasSubmittedByUser">
                                {{ $t('Quotation Module.Please select at least one Submitted By user') }}
                            </small>
                        </div>
                        <div class="quotation-deluxe-signing-field">
                            <div class="quotation-deluxe-signing-field-head">
                                <span class="quotation-deluxe-label">{{$t('Submitted To')}}</span>
                                <p>{{ quotationData.attentionClient.userId?.company || '-' }}</p>
                            </div>
                            <div class="quotation-deluxe-signing-row" v-for="(item, key) in additionalAttention" :key="key">
                                <Select2
                                ref="select2UserFromDirectory"
                                :filterQuery="SearchClientFromProjectDirectory"
                                indexValue="directoryId"
                                labelName="fullname"
                                :placeHolder="$t('Search Here')"
                                :iniLabel="item.name"
                                v-model:optionValue="item.directoryId"
                                :onOptionClick="AddNewAttentionClient"
                                ></Select2>
                                <button type="button" class="quotation-deluxe-remove-button" @click="RemoveAdditionalClientLine(item.directoryId)">
                                    <i class="fa-solid fa-times"></i> {{$t('Remove')}}
                                </button>
                            </div>
                            <small class="quotation-deluxe-validation" v-if="validationErrors.submittedTo || !HasSubmittedToUser">
                                {{ $t('Quotation Module.Please select at least one Submitted To user') }}
                            </small>
                        </div>
                    </div>
                </div>
                <template v-else>
                    <div :class="isDeluxeLayout ? 'col-md-6 col-sm-6 quotation-deluxe-signature-card' : 'col-md-6 pt-5 col-sm-6'">
                        <div :class="isDeluxeLayout ? 'quotation-deluxe-block-title' : 'fw-bold'">{{$t('Submitted By')}} : </div>
                        <div class="">M. Moser Associates (S) Pte Limited</div>
                        <div v-if="!isEditMode">
                            <div class=" signature-padding " v-for="(item, key) in quotationData.submittedTo" :key="key">
                                <div class="border-top width-50 d-none d-print-block"></div>
                                <div v-if="item.signatureBlob">
                                    <img :src="item.signatureBlob" />
                                </div>
                                <div class="text-capitalize">
                                    {{item.userId.fullname}}
                                </div>
                                <span class="small text-capitalize">{{item.roleInProject}}</span>
                            </div>
                        </div>
                        <div v-else>
                            <div class="d-flex mt-2" v-for="(item, key) in submittedTo" :key="key" >
                                <Select2
                                ref="select2UserFromDirectory"
                                :filterQuery="SearchUserFromProjectDirectory"
                                indexValue="directoryId"
                                labelName="fullname"
                                :placeHolder="$t('Search Here')"
                                :iniLabel="item.name"
                                v-model:optionValue="item.directoryId"
                                :onOptionClick="AddNewSubmittedLine"
                                ></Select2>

                                <div  class="ps-2">
                                    <small role="button" class="text-danger" @click="RemoveSubmittedLine(item.directoryId)"><i class="fa-solid fa-times"></i> {{$t('Remove')}}</small>
                                </div>
                            </div>
                            <small class="text-danger" v-if="validationErrors.submittedBy || !HasSubmittedByUser">
                                {{ $t('Quotation Module.Please select at least one Submitted By user') }}
                            </small>
                        </div>
                    </div>
                    <div :class="isDeluxeLayout ? 'col-md-6 col-sm-6 quotation-deluxe-signature-card' : 'col-md-6 pt-5 col-sm-6'">
                        <div :class="isDeluxeLayout ? 'quotation-deluxe-block-title' : 'fw-bold'">{{$t('Submitted To')}} : </div>
                        <div>
                            <div v-if="quotationData.attentionClient.userId">
                                {{quotationData.attentionClient.userId.company || '-'}}
                            </div>

                        </div>

                        <div v-if="!isEditMode">
                            <!-- <div class="signature-padding  ">
                                <div class="border-top width-50 d-none d-print-block"></div>
                                <span class="text-muted"></span>
                                <span  class="text-capitalize">{{quotationData.attentionClient.userId.fullname || 'N/A'}}</span>
                            </div> -->
                            <div class=" signature-padding " v-for="(item, key) in quotationData.additionalAttention" :key="key">
                                <div class="border-top width-50 d-none d-print-block"></div>
                                <div class="text-capitalize">
                                    {{item.userId.fullname}}
                                </div>
                            </div>
                        </div>
                        <div v-else>
                            <div class="signature-padding  ">
                                <div class="border-top width-50 d-none d-print-block"></div>
                                <span class="text-muted"></span>
                                <!-- <span  class="text-capitalize">{{quotationData.attentionClient.userId.fullname || 'N/A'}}</span> -->
                            </div>
                            <div class="d-flex mt-2" v-for="(item, key) in additionalAttention" :key="key" >
                                <Select2
                                ref="select2UserFromDirectory"
                                :filterQuery="SearchClientFromProjectDirectory"
                                indexValue="directoryId"
                                labelName="fullname"
                                :placeHolder="$t('Search Here')"
                                :iniLabel="item.name"
                                v-model:optionValue="item.directoryId"
                                :onOptionClick="AddNewAttentionClient"
                                ></Select2>

                                <div  class="ps-2">
                                    <small role="button" class="text-danger" @click="RemoveAdditionalClientLine(item.directoryId)"><i class="fa-solid fa-times"></i> {{$t('Remove')}}</small>
                                </div>
                            </div>
                            <small class="text-danger" v-if="validationErrors.submittedTo || !HasSubmittedToUser">
                                {{ $t('Quotation Module.Please select at least one Submitted To user') }}
                            </small>
                        </div>
                    </div>
                </template>
                <!-- <div class="col-md-12 d-print-none">
                    <div class="d-flex justify-content-end ">
                        <div class="btn-group me-1 " role="group" v-show="!isEditMode">
                            <button class="btn btn-primary dropdown-toggle" data-bs-toggle="dropdown"  >
                                <i class="fa-solid fa-gear"></i> Actions
                            </button>
                            <ul class="dropdown-menu" >
                                <li role="button"  @click="()=>{ isEditMode = true}" v-if="permission.indexOf(ModuleActionList.BOQ_QUOTATION_EDIT)>-1">
                                    <a class="dropdown-item"  ><i class="fa-solid fa-edit"></i> Edit </a>
                                </li>
                                <li role="button" >
                                    <a class="dropdown-item" @click="PublishQuotation" 
                                    v-if="quotationDataIntial.approvalStage==ApprovalStageBoq.APPROVED && permission.indexOf(ModuleActionList.BOQ_QUOTATION_PUBLISH)>-1"
                                    >
                                        <i class="fa-solid fa-file-circle-check"></i> Contract Signed
                                    </a>
                                </li>
                                <li role="button" v-if="quotationDataIntial.approvalStage!=ApprovalStageBoq.FOR_APPROVAL && permission.indexOf(ModuleActionList.BOQ_QUOTATION_PUBLISH)>-1" >
                                    <a class="dropdown-item" @click="OpenWorkFlowModal">
                                        <i class="fa-solid fa-file-circle-check"></i> For Approval
                                    </a>
                                </li>
                                <li role="button"> 
                                    <a class="dropdown-item"  @click="ExportToPdf" ><i class="fa-solid fa-file-arrow-down"></i> Print</a>
                                </li>
                            </ul>    
                        </div>
                        
                        <div v-show="isEditMode">
                            <button class="btn btn-default me-1" @click="CancelEdit">
                                <i class="fa-solid fa-times"></i> Close
                            </button>
                            <button class="btn btn-success me-1" @click="UpdateQuotation" :disabled="!CanSaveQuotation">
                                <i class="fa-solid fa-floppy-disk"></i> Save Changes 
                            </button>
                        </div>
                    </div>
                </div> -->
                <div class="d-none d-print-inline pager-count"> </div>
                
            </div> 
        </fieldset>
        
    </div>

    <Modal idModal="ModalNewQuotationAdd" :headerTitle="$t('Add BoQ')" modalSize="modal-md">
        <div class="form-group">
            <label class="required-style">{{$t('Bill Of Quantity')}}</label>
            <input type="text" v-model="newlyCreatedBoq.name" :placeholder="$t('Bill Of Quantity')" class="form-control"  />
        </div>
        <template v-slot:actions>
            <button type="button" ref="closeModalNewQuotationAdd" :class="isDeluxeLayout ? 'custom-btn custom-btn--cancel' : 'btn btn-outline-danger'" data-bs-dismiss="modal">X {{$t('Cancel')}}</button>
            <button type="button" :class="isDeluxeLayout ? 'custom-btn' : 'btn btn-primary'" @click="CreateBoqNew"><i class="fa-solid fa-save"></i> {{$t('Add BoQ')}}</button>
        </template>
    </Modal>
    <Modal idModal="ModalAddBoqQuotation" :headerTitle="$t('Quotation Module.Add Existing BoQ')" modalSize="modal-md">
        <div class="form-group">
            <label class="required-style">{{$t('Bill Of Quantity')}}</label>
            <Select2 
            :filterQuery="SearchBoqNoQuotations"
            indexValue="_id"
            labelName="name"
            :placeHolder="$t('Search Here')"
            ref="select2BoqToQuotation"
            v-model:optionValue="newBoq.boqId"
            :dataOptions="boqList"
            ></Select2>
        </div>
        <template v-slot:actions>
            <button type="button" ref="closeModalAddBoqQuotation" :class="isDeluxeLayout ? 'custom-btn custom-btn--cancel' : 'btn btn-outline-danger'" data-bs-dismiss="modal">X {{ $t('Cancel') }}</button>
            <button type="button" :class="isDeluxeLayout ? 'custom-btn' : 'btn btn-primary'" @click="AddBoqToQuotation"  ><i class="fa-solid fa-save"></i> {{$t('Quotation Module.Add Existing BoQ')}}</button>
        </template>
    </Modal>
    <!-- <Modal idModal="QuotationApprovalModal" headerTitle="Send For Approval Quotation" >
      <div>
       <div class="form-group">
            <label class="required-style">Date End </label>
            <input type="date" v-model="quotationApprovalData.dateEnd" class="form-control"/> 
            <small class="text-warning" v-if="isApprovalClicked && !quotationApprovalData.dateEnd">Required</small>
        </div>
       <div class="form-group">
            <label class="required-style">Process </label>
            <Select2
                indexValue="_id"
                labelName="processName"
                placeHolder="Search Process Here"
                v-model:optionValue="quotationApprovalData.processId"
                :dataOptions="approvalProcessList"
            >
            </Select2>
            <a class="text-primary small"  :href="projectUrl +'/Project/' + projectInfo._id+'/process'">No Process on the list? Click here to Create</a>
            <small class="text-warning" v-if="isApprovalClicked && !quotationApprovalData.processId">Required</small>
        </div>
      </div>
      <template v-slot:actions>
        <button type="button" ref="closeQuotationApprovalModal" class="btn btn-outline-danger" data-bs-dismiss="modal">X Cancel</button>
        <button type="button" class="btn btn-primary" @click="ForApprovalQuotation" ><i class="fas fa-save"></i> Send For Approval</button>
      </template>
    </Modal> -->
    
</template>

<script src="@/assets/boq/BoqQuotation.js">

</script>
<style scoped>
    .width-50{
        width: 50%;
    }
    .signature-padding{
        margin-top:5px
    }

    .quotation-deluxe-back {
        margin: 0.25rem 0 1.8rem;
    }

    .quotation-deluxe-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 2rem;
        margin-bottom: 1.25rem;
    }

    .quotation-deluxe-heading {
        display: flex;
        min-width: 0;
        flex-direction: column;
        gap: 0.25rem;
    }

    .quotation-deluxe-eyebrow {
        color: #777777;
        font-size: 0.865rem;
        font-weight: 600;
        letter-spacing: 0;
        text-transform: uppercase;
    }

    .quotation-deluxe-heading .deluxe-page-title {
        max-width: 64rem;
        margin: 0 0 0.25rem;
        font-size: 2rem;
        line-height: 1.15;
    }

    .quotation-deluxe-attached {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        gap: 0.3rem;
        color: #8a8588;
        font-size: 0.865rem;
    }

    .quotation-deluxe-attached a {
        color: #1c1c1c;
        font-weight: 600;
        text-decoration: none;
    }

    .quotation-deluxe-attached a:hover {
        color: var(--lens-accent);
    }

    .quotation-deluxe-actions {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        justify-content: center;
        gap: 0.8rem;
        min-width: 20rem;
    }

    .quotation-deluxe-action-row {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: flex-end;
        gap: 1.25rem;
    }

    .quotation-deluxe-action-row .custom-btn {
        width: auto;
        min-width: 9.7rem;
    }

    .quotation-deluxe-action-row .quotation-deluxe-save-button {
        background: var(--lens-accent);
        border-color: var(--lens-accent);
        color: #ffffff;
        cursor: pointer;
        transition: background-color 0.15s ease, border-color 0.15s ease, color 0.15s ease, opacity 0.15s ease;
    }

    .quotation-deluxe-action-row .quotation-deluxe-save-button:disabled,
    .quotation-deluxe-action-row .quotation-deluxe-save-button[disabled] {
        background: #e3e3e3;
        border-color: #e3e3e3;
        color: #777777;
        cursor: not-allowed;
        opacity: 1;
        pointer-events: auto;
    }

    .quotation-deluxe-action-row .quotation-deluxe-save-button:not(:disabled):hover,
    .quotation-deluxe-action-row .quotation-deluxe-save-button:not(:disabled):focus {
        background: color-mix(in srgb, var(--lens-accent) 86%, #000000);
        border-color: color-mix(in srgb, var(--lens-accent) 86%, #000000);
        color: #ffffff;
    }

    .quotation-deluxe-action-row .quotation-deluxe-edit-cancel {
        background: #e3e3e3;
        border-color: #e3e3e3;
        border-radius: 0;
        color: #666666;
        font-weight: 700;
    }

    .quotation-deluxe-action-row .quotation-deluxe-edit-cancel:hover,
    .quotation-deluxe-action-row .quotation-deluxe-edit-cancel:focus {
        background: #d8d8d8;
        border-color: #d8d8d8;
        color: #555555;
    }

    .quotation-deluxe-action-button {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 0.55rem;
        min-width: 8rem;
        min-height: 2.6rem;
        border: 0;
        border-radius: 0;
        padding: 0.72rem 1.05rem;
        color: #ffffff;
        font-size: 0.82rem;
        font-weight: 700;
        line-height: 1;
    }

    .quotation-deluxe-action-button--export,
    .quotation-deluxe-action-button--muted {
        background: #687a75;
    }

    .quotation-deluxe-action-button--print {
        background: #00151c;
    }

    .quotation-deluxe-action-button:hover,
    .quotation-deluxe-action-button:focus {
        color: #ffffff;
        filter: brightness(0.96);
    }

    .quotation-deluxe-status-pill {
        width: fit-content;
        justify-content: center;
        font-size: 0.78rem;
        font-weight: 600;
    }

    .quotation-deluxe-currency-note {
        display: block;
        margin: 0.8rem 0 1.25rem;
        color: #777777;
        font-size: 0.865rem;
        font-style: italic;
        text-align: left;
    }

    .quotation-deluxe-content {
        width: 100%;
        min-height: 40rem;
        padding: 2.5rem;
        color: var(--lens-text);
        background: #ffffff;
        box-shadow: 0 0.1rem 0.35rem rgba(30, 27, 22, 0.08);
    }

    .quotation-deluxe-content--edit {
        min-height: 0;
        padding: 0;
        background: transparent;
        box-shadow: none;
    }

    .quotation-deluxe-details {
        margin-bottom: 2rem;
    }

    .quotation-deluxe-card,
    .quotation-deluxe-section,
    .quotation-deluxe-signature-card {
        background: transparent;
        box-shadow: none;
    }

    .quotation-deluxe-card {
        padding: 0;
    }

    .quotation-deluxe-content--edit .quotation-deluxe-summary,
    .quotation-deluxe-content--edit .quotation-deluxe-section,
    .quotation-deluxe-content--edit .quotation-deluxe-signature-card {
        padding: 2rem;
        background: #ffffff;
        box-shadow: 0 0.25rem 0.8rem rgba(30, 27, 22, 0.12);
    }

    .quotation-deluxe-details--edit {
        margin-bottom: 1.5rem;
    }

    .quotation-deluxe-details--edit .quotation-deluxe-card {
        padding: 0;
        background: transparent;
        box-shadow: none;
    }

    .quotation-deluxe-edit-grid {
        display: grid;
        grid-template-columns: minmax(0, 3fr) minmax(19rem, 2fr);
        gap: 1.5rem;
        width: 100%;
    }

    .quotation-deluxe-edit-side {
        display: flex;
        min-width: 0;
        flex-direction: column;
        gap: 1.5rem;
    }

    .quotation-deluxe-edit-card {
        min-width: 0;
        padding: 2rem;
        background: #ffffff;
        box-shadow: 0 0.25rem 0.8rem rgba(30, 27, 22, 0.12);
    }

    .quotation-deluxe-edit-card--main {
        width: 100%;
    }

    .quotation-deluxe-edit-divider {
        margin: 0 0 1.35rem;
        border: 0;
        border-top: 1px solid #dcdcdc;
        opacity: 1;
    }

    .quotation-deluxe-edit-status {
        display: flex;
        align-items: center;
        gap: 0.8rem;
        min-height: 3rem;
        color: #1e1b16;
    }

    .quotation-deluxe-toggle {
        position: relative;
        display: inline-flex;
        width: 2.75rem;
        height: 1.5rem;
        flex: 0 0 auto;
        border: 1px solid #777777;
        border-radius: 999px;
        background: #777777;
    }

    .quotation-deluxe-toggle span {
        position: absolute;
        top: 0.13rem;
        left: 0.15rem;
        width: 1.15rem;
        height: 1.15rem;
        border: 1px solid #777777;
        border-radius: 999px;
        background: #ffffff;
        transition: transform 0.18s ease;
    }

    .quotation-deluxe-toggle.is-active {
        border-color: var(--lens-accent);
        background: var(--lens-accent);
    }

    .quotation-deluxe-toggle.is-active span {
        transform: translateX(1.18rem);
        border-color: #ffffff;
    }

    .quotation-deluxe-edit-status-text {
        display: flex;
        flex-direction: column;
        gap: 0.1rem;
    }

    .quotation-deluxe-edit-status-text strong {
        color: #1e1b16;
        font-size: 1rem;
        font-weight: 700;
        line-height: 1.2;
    }

    .quotation-deluxe-edit-status-text small {
        color: #777777;
        font-size: 0.78rem;
        font-weight: 500;
    }

    .quotation-deluxe-readonly-field {
        display: flex;
        flex-direction: column;
        gap: 0.45rem;
    }

    .quotation-deluxe-readonly-control {
        display: flex;
        min-height: auto;
        align-items: center;
        justify-content: space-between;
        border: 0;
        padding: 0;
        color: #1e1b16;
        background: transparent;
        font-size: 0.95rem;
        font-weight: 600;
        text-decoration: none;
    }

    .quotation-deluxe-readonly-control--link:hover {
        color: var(--lens-accent);
        text-decoration: none;
    }

    .quotation-deluxe-report-head {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        gap: 3rem;
    }

    .quotation-deluxe-report-address {
        display: grid;
        grid-template-columns: minmax(0, 17rem) minmax(0, 1fr);
        gap: 0.25rem 6rem;
        max-width: 60rem;
    }

    .quotation-deluxe-report-label,
    .quotation-deluxe-report-address h2,
    .quotation-deluxe-address-line {
        grid-column: 1;
    }

    .quotation-deluxe-report-meta {
        grid-column: 2;
        grid-row: 2 / span 3;
        display: flex;
        flex-direction: column;
        gap: 0.2rem;
        padding-top: 1rem;
    }

    .quotation-deluxe-report-label {
        color: #1e1b16;
        font-size: 0.875rem;
        font-weight: 600;
    }

    .quotation-deluxe-report-address h2 {
        margin: 0.9rem 0 1.35rem;
        color: #1e1b16;
        font-size: 1rem;
        font-weight: 800;
    }

    .quotation-deluxe-report-address p,
    .quotation-deluxe-report-meta p,
    .quotation-deluxe-report-number p,
    .quotation-deluxe-report-number span {
        margin: 0;
        color: #1f1f1f;
        font-size: 0.875rem;
        line-height: 1.35;
    }

    .quotation-deluxe-report-address span,
    .quotation-deluxe-report-meta span {
        margin-right: 0.25rem;
        color: #1e1b16;
        font-weight: 600;
    }

    .quotation-deluxe-report-address strong,
    .quotation-deluxe-report-meta strong {
        font-weight: 500;
    }

    .quotation-deluxe-report-project strong {
        font-weight: 700;
    }

    .quotation-deluxe-report-number {
        min-width: 13rem;
        text-align: right;
    }

    .quotation-deluxe-report-number h4 {
        margin: 0.35rem 0 0.5rem;
        color: #1e1b16;
        font-size: 1.15rem;
        font-weight: 800;
    }

    .quotation-deluxe-block-title {
        margin-bottom: 0.85rem;
        color: #1e1b16;
        font-size: 1rem;
        font-weight: 700;
    }

    .quotation-deluxe-form-grid {
        display: grid;
        grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
        gap: 1rem 1.35rem;
    }

    .quotation-deluxe-field {
        display: flex;
        min-width: 0;
        flex-direction: column;
        gap: 0.45rem;
        margin: 0;
    }

    .quotation-deluxe-field--wide {
        grid-column: 1 / -1;
    }

    .quotation-deluxe-label {
        color: #1f1f1f;
        font-size: 0.86rem;
        font-weight: 600;
    }

    .quotation-required-label {
        color: #d00000;
        font-weight: 700;
    }

    .quotation-deluxe-control,
    .quotation-deluxe-textarea,
    .quotation-deluxe-content :deep(.select2-design) {
        min-height: 3.125rem;
        border: 1px solid #d9d9d9;
        border-radius: 0;
        color: #1f1f1f;
        font-size: 0.9rem;
        box-shadow: none;
    }

    .quotation-deluxe-content :deep(.select2-design) {
        display: flex;
        align-items: center;
        width: 100%;
        padding: 0.65rem 0.85rem;
    }

    .quotation-deluxe-textarea {
        min-height: 8rem;
        resize: vertical;
    }

    .quotation-deluxe-content :deep(.dropdown-custom-menu),
    .quotation-deluxe-content :deep(.dropup-custom-menu) {
        z-index: 9999;
    }

    .quotation-deluxe-summary {
        margin-top: 0;
    }

    .quotation-deluxe-edit-card-head {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 1.5rem;
        margin-bottom: 1.35rem;
        padding-bottom: 1.35rem;
        border-bottom: 1px solid #dcdcdc;
    }

    .quotation-deluxe-edit-card-head .quotation-deluxe-block-title {
        margin-bottom: 0;
    }

    .quotation-deluxe-summary-actions,
    .quotation-deluxe-link-row {
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-end;
        gap: 0.75rem;
        margin-bottom: 0;
    }

    .quotation-deluxe-table-action {
        width: auto;
        min-width: 9.5rem;
        min-height: 2.65rem;
        gap: 0.55rem;
        padding: 0.72rem 1rem !important;
    }

    .quotation-deluxe-table-action span {
        display: inline;
    }

    .quotation-deluxe-table-action--new {
        background: #687a75 !important;
    }

    .quotation-deluxe-table-action--attach {
        background: #106194 !important;
    }

    .quotation-deluxe-link-row {
        justify-content: flex-start;
        margin-top: 1rem;
    }

    .quotation-deluxe-table-wrap {
        width: 100%;
        overflow-x: auto;
        box-shadow: none;
    }

    .quotation-deluxe-table-wrap :deep(.table) {
        width: 100%;
        margin-bottom: 0;
        border: 0;
        border-collapse: collapse;
        color: #1f1f1f;
        background: #ffffff;
        table-layout: fixed;
        font-size: 0.875rem;
    }

    .quotation-deluxe-table-wrap :deep(.quotation-summary-table + .quotation-summary-table) {
        margin-top: 0;
    }

    .quotation-deluxe-table-wrap :deep(.table th) {
        border: 0;
        border-bottom: 1px solid var(--lens-accent);
        background: color-mix(in srgb, var(--lens-accent) 18%, #ffffff);
        color: var(--lens-accent);
        font-size: 0.86rem;
        font-weight: 800;
        padding: 0.78rem 1.5rem;
        text-transform: none;
    }

    .quotation-deluxe-table-wrap :deep(.table td) {
        border: 0;
        border-bottom: 1px solid #d8d8d8;
        padding: 0.82rem 1.5rem;
        background: #ffffff;
        vertical-align: middle;
    }

    .quotation-deluxe-table-wrap :deep(.table .col-2),
    .quotation-deluxe-table-wrap :deep(.table th:first-child),
    .quotation-deluxe-table-wrap :deep(.table td:first-child) {
        width: 7rem;
        text-align: center;
    }

    .quotation-deluxe-table-wrap :deep(.table th:nth-child(2)),
    .quotation-deluxe-table-wrap :deep(.table td:nth-child(2)) {
        width: auto;
    }

    .quotation-deluxe-table-wrap :deep(.table th:nth-child(3)),
    .quotation-deluxe-table-wrap :deep(.table th:nth-child(4)),
    .quotation-deluxe-table-wrap :deep(.table td:nth-child(3)),
    .quotation-deluxe-table-wrap :deep(.table td:nth-child(4)) {
        width: 14rem;
        text-align: right;
    }

    .quotation-deluxe-table-wrap :deep(.quotation-summary-reference-row td),
    .quotation-deluxe-table-wrap :deep(.quotation-summary-reference-row > *) {
        background: #e7e8eb !important;
        color: #1e1b16;
        font-size: 0.75rem;
        font-weight: 500 !important;
    }

    .quotation-deluxe-table-wrap :deep(.quotation-summary-total-row td),
    .quotation-deluxe-table-wrap :deep(.quotation-summary-total-row > *) {
        background: color-mix(in srgb, var(--lens-accent) 10%, #ffffff) !important;
        font-weight: 800 !important;
    }

    .quotation-deluxe-table-wrap :deep(.quotation-summary-area-row td),
    .quotation-deluxe-table-wrap :deep(.quotation-summary-area-row > *) {
        background: #ffffff !important;
        font-weight: 800 !important;
    }

    .quotation-deluxe-table-wrap :deep(.quotation-summary-section-row td) {
        font-weight: 800;
    }

    .quotation-deluxe-table-wrap :deep(.quotation-summary-sub-row td:nth-child(2)) {
        padding-left: 1.4rem;
    }

    .quotation-deluxe-table-wrap :deep(.link-item-route) {
        color: #002776;
        font-weight: 700;
        text-decoration: none;
    }

    .quotation-deluxe-table-wrap :deep(.link-item-route:hover),
    .quotation-deluxe-table-wrap :deep(.link-item-route:focus) {
        color: var(--lens-accent);
        text-decoration: underline;
    }

    .quotation-deluxe-table-wrap :deep(.link-item-route .fa-arrow-up-right-from-square) {
        display: none;
    }

    .quotation-deluxe-section-row {
        display: grid;
        grid-template-columns: repeat(12, minmax(0, 1fr));
        gap: 0.75rem 1.75rem;
        margin: 2rem 0 0;
    }

    .quotation-deluxe-section-row > .col-md-12,
    .quotation-deluxe-section-row > .col-sm-12 {
        grid-column: 1 / -1;
        width: auto;
        padding: 0;
    }

    .quotation-deluxe-section-row > .col-md-6,
    .quotation-deluxe-section-row > .col-sm-6 {
        grid-column: span 6;
        width: auto;
        padding: 0;
    }

    .quotation-deluxe-section {
        padding: 0;
    }

    .quotation-deluxe-content--edit .quotation-deluxe-section-row {
        gap: 1.5rem;
    }

    .quotation-deluxe-compact-section {
        margin-top: 0.55rem;
    }

    .quotation-deluxe-file-upload {
        position: relative;
        margin-top: 0;
    }

    .quotation-deluxe-file-input {
        position: fixed;
        top: 0;
        left: 0;
        width: 1px;
        height: 1px;
        overflow: hidden;
        opacity: 0;
        pointer-events: none;
        transform: translate(-100vw, -100vh);
    }

    .quotation-deluxe-file-label {
        display: flex;
        min-height: 4rem;
        align-items: center;
        gap: 0.9rem;
        width: 100%;
        margin: 0;
        border: 1px solid #d8d8d8;
        border-left: 3px solid var(--lens-accent);
        padding: 0.8rem 1rem;
        text-align: left;
        color: #1e1b16;
        background: #ffffff;
        cursor: pointer;
        transition: border-color 0.15s ease, box-shadow 0.15s ease;
    }

    .quotation-deluxe-file-label:hover {
        border-color: var(--lens-accent);
        box-shadow: 0 0.2rem 0.55rem rgba(30, 27, 22, 0.08);
    }

    .quotation-deluxe-file-input:focus + .quotation-deluxe-file-label,
    .quotation-deluxe-file-label:focus-within {
        border-color: var(--lens-accent);
        box-shadow: 0 0 0 0.15rem rgba(30, 27, 22, 0.12);
    }

    .quotation-deluxe-file-icon {
        display: inline-flex;
        flex: 0 0 2rem;
        width: 2rem;
        height: 2rem;
        align-items: center;
        justify-content: center;
        color: var(--lens-accent);
        background: var(--lens-accent-soft);
    }

    .quotation-deluxe-file-copy {
        display: flex;
        min-width: 0;
        flex: 1 1 auto;
        flex-direction: column;
        gap: 0.1rem;
    }

    .quotation-deluxe-file-copy strong {
        color: #1e1b16;
        font-size: 0.9rem;
        font-weight: 600;
        line-height: 1.2;
    }

    .quotation-deluxe-file-copy small {
        color: #777777;
        font-size: 0.78rem;
        line-height: 1.2;
    }

    .quotation-deluxe-file-button {
        display: inline-flex;
        flex: 0 0 auto;
        min-height: 2.35rem;
        align-items: center;
        justify-content: center;
        padding: 0 1rem;
        color: #ffffff;
        background: var(--lens-accent);
        font-size: 0.82rem;
        font-weight: 600;
    }

    .quotation-deluxe-html {
        color: #1f1f1f;
        font-size: 0.875rem;
        line-height: 1.5;
        letter-spacing: 0;
        text-align: left;
        text-align-last: auto;
        white-space: normal;
        word-spacing: normal;
    }

    .quotation-deluxe-section--rich :deep(.ProseMirror),
    .quotation-deluxe-section--rich :deep(.ProseMirror *),
    .quotation-deluxe-html :deep(*) {
        letter-spacing: 0 !important;
        text-align: left !important;
        text-align-last: auto !important;
        white-space: normal !important;
        word-spacing: normal !important;
    }

    .quotation-deluxe-section--rich :deep(.ProseMirror) {
        min-height: 12rem;
        line-height: 1.5;
    }

    .quotation-deluxe-section--rich :deep(.ProseMirror p),
    .quotation-deluxe-html :deep(p) {
        margin: 0 0 0.85rem;
    }

    .quotation-deluxe-html :deep(p:last-child) {
        margin-bottom: 0;
    }

    .quotation-deluxe-html :deep(ol),
    .quotation-deluxe-html :deep(ul) {
        margin-top: 0.55rem;
        margin-bottom: 0.9rem;
        padding-left: 1.35rem;
    }

    .quotation-deluxe-html :deep(li) {
        margin-bottom: 0.16rem;
    }

    .quotation-deluxe-attachment-list {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(22rem, 1fr));
        gap: 0.75rem;
        margin-top: 1rem;
    }

    .quotation-deluxe-attachment-list .col-md-4,
    .quotation-deluxe-attachment-item {
        width: auto;
        padding: 0;
    }

    .quotation-deluxe-attachment-item {
        display: flex;
        min-width: 0;
        min-height: 3.4rem;
        align-items: center;
        gap: 0.8rem;
        border: 1px solid #e1e1e1;
        padding: 0.65rem 0.75rem;
        background: #ffffff;
        box-shadow: 0 0.12rem 0.35rem rgba(30, 27, 22, 0.06);
    }

    .quotation-deluxe-attachment-icon {
        display: inline-flex;
        flex: 0 0 2rem;
        width: 2rem;
        height: 2rem;
        align-items: center;
        justify-content: center;
        color: var(--lens-accent);
        background: var(--lens-accent-soft);
        font-size: 0.95rem;
    }

    .quotation-deluxe-attachment-icon.is-pending {
        color: #198754;
        background: rgba(25, 135, 84, 0.1);
    }

    .quotation-deluxe-attachment-copy {
        display: flex;
        min-width: 0;
        flex: 1 1 auto;
        flex-direction: column;
        gap: 0.15rem;
    }

    .quotation-deluxe-attachment-name {
        display: block;
        min-width: 0;
        border: 0;
        padding: 0;
        overflow: hidden;
        color: #1e1b16;
        background: transparent;
        font-size: 0.86rem;
        font-weight: 600;
        line-height: 1.25;
        text-align: left;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    button.quotation-deluxe-attachment-name:hover,
    button.quotation-deluxe-attachment-name:focus {
        color: var(--lens-accent);
        text-decoration: underline;
    }

    .quotation-deluxe-attachment-copy small {
        color: #777777;
        font-size: 0.74rem;
        line-height: 1.2;
    }

    .quotation-deluxe-attachment-remove {
        display: inline-flex;
        flex: 0 0 auto;
        align-items: center;
        gap: 0.35rem;
        border: 0;
        padding: 0.25rem;
        color: #d93025;
        background: transparent;
        font-size: 0.76rem;
        font-weight: 600;
        white-space: nowrap;
    }

    .quotation-deluxe-attachment-remove:hover,
    .quotation-deluxe-attachment-remove:focus {
        color: #9f1d15;
        text-decoration: none;
    }

    .quotation-deluxe-attachment-list .input-group {
        align-items: stretch;
        margin-bottom: 0 !important;
        border: 1px solid #e1e1e1;
        background: #ffffff;
        box-shadow: 0 0.15rem 0.45rem rgba(30, 27, 22, 0.08);
    }

    .quotation-deluxe-attachment-list .input-group-text {
        border: 0;
        color: var(--lens-accent);
        background: transparent !important;
    }

    .quotation-deluxe-attachment-list .form-control {
        border: 0;
        color: #002776;
        background: transparent;
        box-shadow: none;
        font-size: 0.84rem;
    }

    .quotation-deluxe-attachment-list .text-danger {
        display: inline-flex;
        align-items: center;
        gap: 0.25rem;
        padding-right: 0.75rem;
        font-size: 0.78rem;
        text-decoration: none;
    }

    .quotation-deluxe-signature-card {
        padding: 1.2rem 0 0;
        font-size: 0.875rem;
        line-height: 1.35;
    }

    .quotation-deluxe-signature-card .signature-padding {
        margin-top: 0.3rem;
    }

    .quotation-deluxe-signing-card {
        position: relative;
        grid-column: 1 / -1;
        overflow: visible;
        margin-top: 1.15rem;
        padding: 2rem;
        border: 0;
        background: #ffffff;
        box-shadow: 0 0.25rem 0.8rem rgba(30, 27, 22, 0.12);
        z-index: 10;
    }

    .quotation-deluxe-signing-card > .quotation-deluxe-block-title {
        margin: 0;
        padding-bottom: 0;
        border-bottom: 0;
        font-size: 0.98rem;
        line-height: 1.2;
    }

    .quotation-deluxe-signing-card .quotation-deluxe-edit-divider {
        display: none;
    }

    .quotation-deluxe-signing-grid {
        display: grid;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: 1.2rem;
        margin-top: 1.2rem;
        overflow: visible;
    }

    .quotation-deluxe-signing-field {
        position: relative;
        display: flex;
        min-width: 0;
        overflow: visible;
        flex-direction: column;
        gap: 0.85rem;
        border: 1px solid #ececec;
        border-left: 3px solid var(--lens-accent);
        padding: 1rem;
        background: #fbfbfb;
        box-shadow: 0 0.1rem 0.35rem rgba(30, 27, 22, 0.04);
    }

    .quotation-deluxe-signing-field-head {
        display: flex;
        min-width: 0;
        flex-direction: column;
        gap: 0.25rem;
        padding-bottom: 0.15rem;
    }

    .quotation-deluxe-signing-field p {
        min-height: 0;
        margin: 0;
        color: #555555;
        font-size: 0.82rem;
        line-height: 1.35;
    }

    .quotation-deluxe-signing-row {
        position: relative;
        display: flex;
        align-items: center;
        gap: 0.55rem;
        min-width: 0;
        overflow: visible;
    }

    .quotation-deluxe-signing-row :deep(.dropdown) {
        flex: 1 1 auto;
        min-width: 0;
        width: 100%;
        overflow: visible;
    }

    .quotation-deluxe-signing-row :deep(.select2-design) {
        width: 100%;
        min-height: 2.75rem;
        min-width: 0;
        border-radius: 0;
        background: #ffffff;
        font-size: 0.86rem;
    }

    .quotation-deluxe-signing-row :deep(.dropdown-custom-menu),
    .quotation-deluxe-signing-row :deep(.dropup-custom-menu) {
        width: 100%;
        min-width: 100%;
        max-height: 18rem;
        overflow-y: auto;
        z-index: 10000;
    }

    .quotation-deluxe-remove-button {
        display: inline-flex;
        flex: 0 0 auto;
        min-height: 2.75rem;
        align-items: center;
        justify-content: center;
        gap: 0.35rem;
        border: 1px solid #f0c6c1;
        padding: 0 0.7rem;
        color: #d93025;
        background: #ffffff;
        font-size: 0.76rem;
        font-weight: 600;
        white-space: nowrap;
    }

    .quotation-deluxe-remove-button:hover,
    .quotation-deluxe-remove-button:focus {
        color: #ffffff;
        background: #d93025;
        text-decoration: none;
    }

    .quotation-deluxe-validation {
        display: block;
        margin-top: -0.25rem;
        color: #d93025;
        font-size: 0.78rem;
        font-weight: 700;
        line-height: 1.35;
    }

    .quotation-deluxe-workflow {
        margin-bottom: 1.5rem;
    }

    .quotation-deluxe-content .custom-btn:disabled {
        opacity: 0.6;
        cursor: not-allowed;
    }

    @media (max-width: 992px) {
        .quotation-deluxe-header,
        .quotation-deluxe-report-head {
            align-items: flex-start;
            flex-direction: column;
        }

        .quotation-deluxe-actions {
            justify-content: flex-start;
        }

        .quotation-deluxe-form-grid {
            grid-template-columns: 1fr;
        }

        .quotation-deluxe-edit-grid {
            grid-template-columns: 1fr;
        }

        .quotation-deluxe-edit-card-head {
            align-items: flex-start;
            flex-direction: column;
        }

        .quotation-deluxe-signing-grid {
            grid-template-columns: 1fr;
        }

        .quotation-deluxe-section-row > .col-md-6,
        .quotation-deluxe-section-row > .col-sm-6 {
            grid-column: 1 / -1;
        }

        .quotation-deluxe-report-number {
            text-align: left;
        }

        .quotation-deluxe-report-address {
            grid-template-columns: 1fr;
        }

        .quotation-deluxe-report-meta {
            grid-column: 1;
            grid-row: auto;
            padding-top: 0.25rem;
        }

        .quotation-deluxe-content {
            padding: 1.5rem;
        }
    }

    @page {
        size: A4 landscape;
        margin: 8mm;
    }

    @media print {
        :global(html),
        :global(body),
        :global(#app),
        :global(.deluxe-layout),
        :global(.deluxe-layout .wrapper),
        :global(.deluxe-layout .wrapper__inner),
        :global(.deluxe-layout .content),
        :global(.deluxe-layout .content__wrapper),
        :global(.deluxe-layout .content__inner) {
            width: 100% !important;
            height: auto !important;
            min-height: 0 !important;
            max-height: none !important;
            overflow: visible !important;
        }

        :global(.deluxe-layout .wrapper__inner),
        :global(.deluxe-layout .content) {
            display: block !important;
        }

        :global(.deluxe-layout .content) {
            flex: none !important;
        }

        :global(.deluxe-layout .content__wrapper) {
            padding: 0 !important;
        }

        :global(.deluxe-layout .deluxe-sidebar),
        :global(.deluxe-layout .deluxe-sidebar__collapse),
        :global(.deluxe-layout .content__top) {
            display: none !important;
        }

        .border{
            border: none !important;
        }
        .border-top {
            border-top:1px solid black !important
        }
        .print-content {
            font-size : 8px !important;
        }
        .quotation-deluxe-currency-note {
            margin: 0 0 1rem !important;
            text-align: center !important;
        }

        .quotation-deluxe-content,
        .quotation-deluxe-details,
        .quotation-deluxe-card,
        .quotation-deluxe-summary,
        .quotation-deluxe-section,
        .quotation-deluxe-signature-card {
            width: 100% !important;
            height: auto !important;
            min-height: 0 !important;
            max-height: none !important;
            overflow: visible !important;
            box-shadow: none !important;
            background: #ffffff !important;
        }

        .quotation-deluxe-content {
            padding: 0 !important;
        }

        .quotation-deluxe-details {
            margin-bottom: 1rem !important;
        }

        .quotation-deluxe-report-head {
            display: flex !important;
            gap: 2rem !important;
            margin-bottom: 1.25rem !important;
            break-inside: avoid;
            page-break-inside: avoid;
        }

        .quotation-deluxe-report-address {
            display: grid !important;
            grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) !important;
            gap: 0.25rem 3rem !important;
            max-width: none !important;
        }

        .quotation-deluxe-report-address h2,
        .quotation-deluxe-report-address p,
        .quotation-deluxe-report-meta p,
        .quotation-deluxe-report-number p,
        .quotation-deluxe-report-number span {
            font-size: 8px !important;
            line-height: 1.25 !important;
        }

        .quotation-deluxe-report-address h2 {
            margin: 0.45rem 0 0.8rem !important;
        }

        .quotation-deluxe-table-wrap {
            width: 100% !important;
            max-width: 100% !important;
            overflow: visible !important;
            box-shadow: none !important;
        }

        .quotation-deluxe-table-wrap :deep(.table) {
            width: 100% !important;
            min-width: 0 !important;
            table-layout: fixed !important;
            font-size: 8px !important;
        }

        .quotation-deluxe-table-wrap :deep(.table thead),
        .quotation-deluxe-table-wrap :deep(.table tbody) {
            display: table-row-group;
        }

        .quotation-deluxe-table-wrap :deep(.table tr) {
            break-inside: avoid;
            page-break-inside: avoid;
        }

        .quotation-deluxe-table-wrap :deep(.table th),
        .quotation-deluxe-table-wrap :deep(.table td) {
            padding: 0.22rem 0.35rem !important;
            white-space: normal !important;
            overflow-wrap: anywhere !important;
            word-break: normal !important;
            print-color-adjust: exact;
            -webkit-print-color-adjust: exact;
        }

        .quotation-deluxe-table-wrap :deep(.table .col-2),
        .quotation-deluxe-table-wrap :deep(.table th:first-child),
        .quotation-deluxe-table-wrap :deep(.table td:first-child) {
            width: 7% !important;
        }

        .quotation-deluxe-table-wrap :deep(.table th:nth-child(2)),
        .quotation-deluxe-table-wrap :deep(.table td:nth-child(2)) {
            width: 53% !important;
        }

        .quotation-deluxe-table-wrap :deep(.table th:nth-child(3)),
        .quotation-deluxe-table-wrap :deep(.table th:nth-child(4)),
        .quotation-deluxe-table-wrap :deep(.table td:nth-child(3)),
        .quotation-deluxe-table-wrap :deep(.table td:nth-child(4)) {
            width: 20% !important;
            text-align: right !important;
        }

        .quotation-deluxe-section-row {
            display: block !important;
            margin-top: 0 !important;
        }

        .quotation-deluxe-section-row > .col-md-12,
        .quotation-deluxe-section-row > .col-sm-12,
        .quotation-deluxe-section-row > .col-md-6,
        .quotation-deluxe-section-row > .col-sm-6 {
            display: block !important;
            float: none !important;
            width: 100% !important;
            padding: 0 !important;
        }

        .quotation-deluxe-html {
            font-size: 8px !important;
            line-height: 1.35 !important;
        }

        .break-after {
            break-after: page;
            page-break-after: always;
        }

        .signature-padding{
            margin-top:50px
        }

        .quotation-deluxe-section-row > .quotation-deluxe-signature-card {
            display: inline-block !important;
            float: none !important;
            width: 49% !important;
            padding-top: 1.35rem !important;
            color: #000000 !important;
            font-size: 7px !important;
            line-height: 1.25 !important;
            vertical-align: top !important;
            break-inside: avoid;
            page-break-inside: avoid;
        }

        .quotation-deluxe-section-row > .quotation-deluxe-signature-card + .quotation-deluxe-signature-card {
            margin-left: 2% !important;
        }

        .quotation-deluxe-signature-card .quotation-deluxe-block-title {
            margin-bottom: 0.35rem !important;
            color: #000000 !important;
            font-size: 7px !important;
            font-weight: 800 !important;
            line-height: 1.2 !important;
        }

        .quotation-deluxe-signature-card .signature-padding {
            margin-top: 1.6rem !important;
        }

        .quotation-deluxe-signature-card .border-top {
            width: 14rem !important;
            margin-bottom: 0.35rem !important;
            border-top: 1px solid #000000 !important;
        }

        .quotation-deluxe-signature-card .small {
            font-size: 6.5px !important;
        }

        .quotation-deluxe-signature-card img {
            max-width: 14rem !important;
            max-height: 3rem !important;
        }

        :global(body) {
            margin-top: 0.1mm;
            margin-bottom: 0.15mm;
            margin-right: 0.30mm;
            margin-left: 0.30mm;
        }

        .table>:not(caption)>*>* {
            padding: 0.2rem 0.2rem;
        }

        .bg-light{
            print-color-adjust: exact;
            -webkit-print-color-adjust: exact;
        }

        .bg-separator{
            font-weight: 600;
            padding-top: 0;
            background-color: transparent !important;
            print-color-adjust: exact;
            -webkit-print-color-adjust: exact;
            border-bottom: 0;
        }
        
    }
    
</style>
